import { AvailableErrors } from '@api/izibizi-xp';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';
import { useServiceError } from '@store';
import { useMemo } from 'react';

interface ErrorModalOutput {
	resources: ErrorModalResources;
	typeError: Error;
	onCloseRequest: () => void;
}

interface ErrorModalResources {
	titleCAE: string;
	subtitleCAE1: string;
	subtitleCAELink: string;
	subtitleCAEtextLink: string;
	subtitleCAE2: string;
	titleAML: string;
	subtitleAML: string;
	footerTitle: string;
	footerSubtitle: string;
	exitURL: string;
}
type Error = 'CAE' | 'AML';
export const useErrorCaeOrAmlHelper = (): ErrorModalOutput => {
	const t = useTranslation();
	const { navigateCustomUrl } = useNavigation();
	const error = useServiceError();

	const typeError: Error = error && error.code === AvailableErrors.IziBiziRiskAML ? 'AML' : 'CAE';
	const resources = useMemo((): ErrorModalResources => {
		return {
			titleCAE: t('modals.error.cae.title'),
			subtitleCAE1: t('modals.error.cae.subtitle1'),
			subtitleCAEtextLink: t('modals.error.cae.subtitle.link.text'),
			subtitleCAELink: t('modals.error.cae.subtitle.link.url'),
			subtitleCAE2: t('modals.error.cae.subtitle2'),
			titleAML: t('modals.error.aml.title'),
			subtitleAML: t('modals.error.aml.subtitle'),
			footerTitle: t('modals.error.footer.title'),
			footerSubtitle: t('modals.error.footer.subtitle'),
			exitURL: t('modals.error.exit.url'),
		};
	}, [t]);

	const onCloseRequest = () => {
		navigateCustomUrl(resources.exitURL);
	};

	return { resources, typeError, onCloseRequest };
};
